/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const SignInFormSchema = new Schema({
  password: {
    type: 'string',
    minLength: 1,
    required: true
  },
  username: {
    type: 'string',
    minLength: 1,
    required: true
  }
})

export default SignInFormSchema
